module.exports = __webpack_public_path__ + "3178d9dc9bfe677e345ebf1260835d63.MP3";